import { Box, Typography } from '@mui/material';
import momentTz from 'moment-timezone';

import { FHTooltip } from '../base';
import { FORTA_BLUE, FORTA_GRAY2, FORTA_WHITE } from '../../utils/colors';

import type { Moment } from 'moment-timezone';

interface IClientTimezoneDisplayProps {
  dateTime?: Moment | null;
  zone: string;
  abbreviatedZone: string;
  message?: string;
  selectedClientId?: string | number | null;
  sx?: any;
}

function ClientTimezoneDisplay({
  dateTime,
  zone,
  abbreviatedZone,
  selectedClientId,
  message = '--',
  sx = {},
}: IClientTimezoneDisplayProps) {
  const dateString = dateTime
    ? `${momentTz(dateTime).tz(zone).format('MM/DD/YYYY h:mm A')}`
    : message;
  return (
    <Box
      sx={{
        height: 40,
        display: 'flex',
        textAlign: 'left',
        cursor: 'not-allowed',
        border: `1px solid ${FORTA_BLUE.light1}`,
        borderRadius: '8px',
        ...sx,
      }}
    >
      <FHTooltip
        arrow
        disableHoverListener={!selectedClientId || !dateTime}
        title={dateString}
        sx={{
          borderRadius: '8px',
          display: 'flex',
          maxWidth: '400px',
          padding: '10px',
        }}
        tooltipBoxShadow={'0px 4px 4px rgba(0, 0, 0, 0.25)'}
        tooltipbackground={FORTA_WHITE}
      >
        <Box
          sx={{
            flexGrow: 1,
            pl: 1,
            pt: 0.8,
            width: '100%',
          }}
        >
          <Typography sx={{ fontSize: 14 }} noWrap>
            {dateString}
          </Typography>
        </Box>
      </FHTooltip>
      {selectedClientId && (
        <FHTooltip
          arrow
          disableHoverListener={!selectedClientId}
          title={`Client's timezone is ${zone.replaceAll('_', ' ')} (${abbreviatedZone})`}
          sx={{
            borderRadius: '10px',
            display: 'flex',
            maxWidth: '400px',
            padding: '10px',
          }}
          tooltipBoxShadow={'0px 4px 4px rgba(0, 0, 0, 0.25)'}
          tooltipbackground={FORTA_WHITE}
        >
          <Box
            sx={{
              cursor: 'pointer',
              p: 1,
              borderLeft: 'none',
              borderRadius: '0 8px 8px 0',
              backgroundColor: FORTA_GRAY2,
              textAlign: 'left !important',
            }}
          >
            {selectedClientId ? (
              <Typography textAlign="left" fontSize={14}>
                {abbreviatedZone}
              </Typography>
            ) : (
              <Typography sx={{ mt: -0.2 }}>-</Typography>
            )}
          </Box>
        </FHTooltip>
      )}
    </Box>
  );
}

export default ClientTimezoneDisplay;
